<div class="overlay-component" [ngStyle]="overlayStyles">
  <div *ngIf="title" class="overlay-component-title">{{ title }}</div>
  <div *ngIf="content" class="overlay-component-content">{{ content }}</div>
  <div class="overlay-component-spinner-container" *ngIf="showSpinner">
    <app-loading-dots size="5px"></app-loading-dots>
  </div>
</div>
